// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__20Ex8","chips":"styles_chips__Y61RB","chip":"styles_chip__3ADEZ"};